import CobranzasPorAgenciaPage from "./CobranzasPorAgenciaPage";

export {CobranzasPorAgenciaPage}
export default CobranzasPorAgenciaPage
